import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { IndexComponent } from './index/index.component';
import { PsicoanecdotasComponent } from './psicoanecdotas/psicoanecdotas.component';
import { ContactoComponent } from './contacto/contacto.component';

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
};
const routes: Routes = [
  { path: '#inicio', component: IndexComponent },
  { path: '#sobreMi', component: IndexComponent },
  { path: '#metodoDeTrabajo', component: IndexComponent },
  { path: '#areasDeIntervencion', component: IndexComponent },
  { path: '#talleres', component: IndexComponent },
  { path: 'psicoanecdotas', component: PsicoanecdotasComponent },
  { path: 'contacto', component: ContactoComponent },
  { path: '', component: IndexComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
